import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Floating "back to top" button — positioned on the LEFT side per brief.
 * Visible only after the user scrolls past 300px.
 */
const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Scroll to top"
      /* Hidden with opacity rather than display, so it also has to be taken
         out of the tab order — otherwise keyboard users hit an invisible
         control before they have scrolled anywhere. */
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className={`fixed left-4 sm:left-6 bottom-6 z-40 h-12 w-12 rounded-full bg-primary text-primary-foreground shadow-2xl border border-white/15 backdrop-blur-md flex items-center justify-center transition-all duration-300 hover:bg-primary-dark hover:scale-110 hover:shadow-[0_18px_36px_-10px_hsl(var(--primary)/0.6)] ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default ScrollTopButton;
